import React, { Fragment, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Calendar, Clock, RefreshCcw, Edit, Trash, Video } from "lucide-react";
import "./ViewEventModal.css";
import ConfirmDelete from "./ConfirmDeleteModal.js";
import EditEventModal from "./EditEventModal.js";

const formatDateForInput = (dateString) => {
  const localDate = new Date(dateString);
  const options = { month: 'short', day: '2-digit', year: 'numeric' };
  return localDate.toLocaleDateString('en-US', options);
};

const groupOptions = [
  { value: "stg90", label: "STG Group" },
  { value: "boa", label: "BOA Group" },
  { value: "club84", label: "CLUB84 Group" },
];

const repeatOptions = [
  { value: "once", label: "Once" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "biweekly", label: "Bi-Weekly" },
];

const ViewEventModal = ({ isOpen, onClose, data, setRefreshEventData }) => {
  const { id, title, description, meeting_url, start, end, repeat, group_code } = data || {};
  const formattedStartDate = formatDateForInput(start);
  const repeatLabel = repeatOptions.find(option => option.value === repeat)?.label || '';

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

  const toggleDeleteModal = (id) => {
    setDeleteEvent(id);
    setConfirmDelete(!confirmDelete);
    onClose();
  };

  const openEditModal = () => {
    setIsEditModalOpen(true);
    onClose(); // Close ViewEventModal when EditEventModal opens
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setRefreshEventData(true); // Refresh events after editing
  };

  // console.log(data, 'Event is here..')

  return (
    <div>
      <Modal show={isOpen} onHide={onClose} centered>
        <Modal.Header closeButton style={{ borderBottom: "none" }}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="event-details">
            <div className="event-detail">
              <Calendar className="event-icon" />
              <span>{formattedStartDate}</span>
            </div>
            <div className="event-detail">
              <Clock className="event-icon" />
              <span>{new Date(start).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
              })}</span>
            </div>
            <div className="event-detail">
              <RefreshCcw className="event-icon" />
              <span>{repeatLabel}</span>
            </div>
            <div className="event-detail">
              <strong>Event Agenda</strong>
              <div>{description}</div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", justifyContent: "space-between" }}>
          {userDetails && userDetails.admin && (
            <Fragment>
              <button className="edit-btn" onClick={() => openEditModal()}>
                <Edit /> Edit
              </button>
              <button className="delete-btn" onClick={() => toggleDeleteModal(id)}>
                <Trash /> Delete
              </button>
            </Fragment>
          )}
          <a href={meeting_url} target="_blank" rel="noopener noreferrer" className="join-call-btn">
            <Video /> Join Call
          </a>
        </Modal.Footer>
      </Modal>
      <ConfirmDelete
        isOpenModal={confirmDelete}
        onCloseModal={() => setConfirmDelete(false)}
        id={deleteEvent}
        setRefreshEventData={setRefreshEventData}
      />
      <EditEventModal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        setRefreshEventData={setRefreshEventData}
        event={data}
      />
    </div>
  );
};

export default ViewEventModal;
